'use strict';

angular.module('membership')
  .controller('UserManagerDetailsCtrl', [
    '$scope', 'manageUsersDetailsViewModel', '$stateParams',
    function($scope, viewModel, $stateParams) {
      $scope.viewModel = new viewModel($stateParams.filter, $stateParams.action, $stateParams.userId);
    }
  ]);